import { BsClockHistory } from "react-icons/bs";
import Moment from "react-moment";
import roundUSD from "../../../../utils/roundUSD";

export default function PriceLine({ price }: any) {
  return (
    <div className="px-4 flex">
      <div className="w-12 flex flex-col justify-center items-center">
        <div
          className="flex justify-center items-center w-8 h-8 rounded-full border"
          style={{ backgroundColor: "#E2E2E2" }}
        >
          <BsClockHistory className="#FFF" />
        </div>
        <div className="">
          <div className="border-l border-gray-300 h-12"></div>
          <div className=""></div>
        </div>
      </div>
      <div className="flex-1">
        <div className="mt-1">
          Date: <Moment format="DD/MM/YYYY">{price?.date}</Moment>
        </div>
        <div className="flex flex-col" style={{ fontSize: 11 }}>
          <div className="flex justify-between">
            <div className="">VAT Exclusive</div>
            <div className="">{roundUSD(price?.exclusive)} USD</div>
          </div>
          <div className="flex justify-between">
            <div className="">VAT Inclusive</div>
            <div className="">{roundUSD(price?.inclusive)} USD</div>
          </div>
        </div>
      </div>
    </div>
  );
}
